module.exports = __webpack_public_path__ + "img/xiaodang_jingpai@3x.713cc07b.png";